import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'
import { EmployeeType as Type } from 'modules/contracts/hooks/useFetchFrenchContractData'
import { getEmployeeType } from 'modules/contracts/lib/frenchCountrySpecifics'

interface Props {
  types: Type[]
  employeeId: string
}

const EmployeeType = ({ types, employeeId }: Props) => {
  const employeeType = getEmployeeType(types, employeeId)

  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.employee_type')}
      description={employeeType?.label}
    />
  )
}

export default observer(EmployeeType)
